<template>
  <!-- 网点管理 -->
  <div class="page-container">
    <div class="page-top-tool">
      <!-- <el-button v-if="userPrower == '1'" type="success" icon="el-icon-plus" size="mini" @click="toAddStorePage">新增名片</el-button> -->
      <div class="right-search">
        <span style="margin-left: 20px;">用户编号：</span>
        <el-input v-model="user_no" clearable placeholder="请输入用户编号" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <span style="margin-left: 20px;">姓名：</span>
        <el-input v-model="name" clearable placeholder="请输入个人姓名" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <span style="margin-left: 20px;">手机号：</span>
        <el-input v-model="phone" clearable placeholder="请输入手机号" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <el-button type="primary" icon="el-icon-search" size="mini" :disabled="loading" style="margin-left: 20px;" @click="onSearch">搜索</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      v-loading="loading"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      style="width: 100%; font-size: 12px; margin: 20px 0px;"
      :header-cell-style="tableHeaderColor"
    >
    <el-table-column prop="user_no" label="用户编号" width=""></el-table-column>
    <el-table-column prop="name" label="姓名" width=""></el-table-column>
    <el-table-column label="头像" width="">
      <template slot-scope="scope">
        <img :src="`${baseurl}/${scope.row.photo_pic}`" style="width: 50px; height: 50px; border: 1px solid #eee; margin-right: 10px;" v-if="scope.row.photo_pic" alt="">
      </template>
    </el-table-column>
      <!-- <el-table-column label="性别" width="">
        <template slot-scope="scope">
          <span v-if="scope.row.sex == '1'">男</span>
          <span v-else-if="scope.row.sex == '2'">女</span>
          <span v-else>未知</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="company_name" label="公司名称" width=""></el-table-column> -->
      <!-- <el-table-column prop="job_title" label="职务" width="100"></el-table-column> -->
      <el-table-column prop="phone" label="手机号" width=""></el-table-column>
      <!-- <el-table-column prop="telephone" label="手机号2" width=""></el-table-column> -->
      <!-- <el-table-column prop="email" label="邮箱" width=""></el-table-column> -->
       <el-table-column label="版本" width="">
        <template slot-scope="scope">
          <span v-if="scope.row.card_version == '1'">个人版</span>
          <span v-if="scope.row.card_version == '2' && scope.row.is_company_admin == '1'">团队版（管理员）</span>
          <span v-if="scope.row.card_version == '2' && scope.row.is_company_admin == '-1'">团队版（员工）</span>
          <span v-if="scope.row.card_version == '4' && scope.row.is_company_admin == '1'">企业版（管理员）</span>
          <span v-if="scope.row.card_version == '4' && scope.row.is_company_admin == '-1'">企业版（员工）</span>
        </template>
      </el-table-column>
      <el-table-column label="账号状态" width="">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == '1'" type="success" size="mini">正常</el-tag>
          <el-tag v-else-if="scope.row.status == '2'" type="info" size="mini">停用</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="userPrower == '1'" label="操作" width="">
        <template slot-scope="scope">
          <el-button type="text" size="mini" icon="el-icon-view" @click="showDetail(scope.row)">查看详情</el-button>
          <!-- <el-button type="text" size="mini" @click="onUpdateState(scope)">
            {{ scope.row.state == '1' ? '停用' : '启用' }}
          </el-button>
          <el-button type="text" size="mini" icon="el-icon-edit" @click="onUpdate(scope)">编辑</el-button>
          <el-button type="text" size="mini" icon="el-icon-delete" @click="onDelete(scope)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
    :current-page.sync="currentPage"
    :page-size="pageSize"
    hide-on-single-page
    background
    layout="total, prev, pager, next"
    :total="total"
    @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 查看详情 -->
    <el-dialog title="名片详情" :visible.sync="dialogDetailVisible" @close="imageDialogClose" :show-close="true" style="margin-top: -50px;">
      <div class="active-detail" style="text-align: center;margin-top: -20px;">
        <el-descriptions class="margin-top" :column="2" border>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-xingming"></i>
                姓名
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.name }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-touxiang"></i>
                头像
              </div>
            </template>
            <div style="width: 150px;">
              <el-tooltip placement="top">
                <img :src="`${baseurl}/${activeObj.photo_pic}`" style="width: 50px; height: 50px; border: 1px solid #eee; margin-right: 10px;" v-if="activeObj.photo_pic" alt="">
                <div slot="content">
                  <img v-if="activeObj.photo_pic" :src="`${baseurl}/${activeObj.photo_pic}`" style="width: 300px;" alt="">
                </div>
              </el-tooltip>
            </div>
          </el-descriptions-item>
          <!-- <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-xingbie"></i>
                性别
              </div>
            </template>
            <div style="width: 150px">
              <span v-if="activeObj.sex == '1'">男</span>
              <span v-else-if="activeObj.sex == '2'">女</span>
              <span v-else>未知</span>
            </div>
          </el-descriptions-item> -->
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-gongsimingcheng"></i>
                公司名称
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.company_name }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-zhiwu"></i>
                职务
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.job_title }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-shoujihao"></i>
                手机号
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.phone }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-icon-zuojihao"></i>
                座机号
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.telephone }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-youxiang"></i>
                邮箱
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.email }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-gongsidizhi"></i>
                公司地址
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.address }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-weixinhao"></i>
                微信号
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.weixin }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-weixinerweima"></i>
                微信二维码
              </div>
            </template>
            <div style="width: 150px">
              <el-tooltip placement="top">
                <img :src="`${baseurl}/${activeObj.wxcode}`" style="width: 50px; height: 50px; border: 1px solid #eee; margin-right: 10px;" v-if="activeObj.wxcode" alt="">
                <div slot="content">
                  <img v-if="activeObj.wxcode" :src="`${baseurl}/${activeObj.wxcode}`" style="width: 300px;" alt="">
                </div>
              </el-tooltip>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-mingpianjiaxiaochengxuicon_erweima"></i>
                名片二维码
              </div>
            </template>
            <div style="width: 150px">
              <el-tooltip placement="top">
                <img :src="`${activeObj.qrcode}`" style="width: 50px; height: 50px; border: 1px solid #eee; margin-right: 10px;" v-if="activeObj.qrcode" alt="">
                <div slot="content">
                  <img v-if="activeObj.qrcode" :src="`${activeObj.qrcode}`" style="width: 300px;" alt="">
                </div>
              </el-tooltip>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-poster"></i>
                名片海报
              </div>
            </template>
            <div style="width: 150px">
              <el-tooltip placement="top">
                <img :src="`${baseurl}/${activeObj.card_pic}`" style="width: 100px; height: 50px; border: 1px solid #eee; margin-right: 10px;" v-if="activeObj.card_pic" alt="">
                <div slot="content">
                  <img v-if="activeObj.card_pic" :src="`${baseurl}/${activeObj.card_pic}`" style="width: 300px;" alt="">
                </div>
              </el-tooltip>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-dengji"></i>
                代理等级
              </div>
            </template>
            <div style="width: 150px">
              <span v-if="activeObj.is_agent == '-1'">无</span>
              <span v-else-if="activeObj.is_agent == '1'">合伙人</span>
              <span v-else-if="activeObj.is_agent == '2'">二级代理</span>
              <span v-else-if="activeObj.is_agent == '3'">一级代理</span>
            </div>
          </el-descriptions-item>
          <!-- <el-descriptions-item v-if="activeObj.is_agent != '-1'">
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-yaoqingma"></i>
                邀请码
              </div>
            </template>
            <div style="width: 150px">
              <span>{{ activeObj.invite_code }}</span>
            </div>
          </el-descriptions-item> -->
          <!-- <el-descriptions-item v-if="activeObj.is_agent != '-1'">
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-tubiao_lianmeng-yaoqingma"></i>
                邀请二维码
              </div>
            </template>
            <div style="width: 150px">
              <el-tooltip placement="top">
                <img :src="`${baseurl}/${activeObj.invite_code_url}`" style="width: 50px; height: 50px; border: 1px solid #eee; margin-right: 10px;" v-if="activeObj.qrcode" alt="">
                <div slot="content">
                  <img v-if="activeObj.invite_code_url" :src="`${baseurl}/${activeObj.invite_code_url}`" style="width: 300px;" alt="">
                </div>
              </el-tooltip>
            </div>
          </el-descriptions-item> -->
          <!-- <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-dianzihuace"></i>
                电子画册编号
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.ebook_no }}
            </div>
          </el-descriptions-item> -->
          <!-- <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-website"></i>
                电子画册地址
              </div>
            </template>
            <div style="width: 150px">
              <a :href="activeObj.ebook_url" target="_blank" class="url-style">{{ activeObj.ebook_url }}</a>
            </div>
          </el-descriptions-item> -->
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                <i class="iconfont icon-chuangjianshijian"></i>
                创建时间
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.create_time }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item v-if="activeObj.update_time">
            <template slot="label">
              <div style="width: 120px;">
                <i class="iconfont icon-xiugaishijian"></i>
                最后修改时间
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.update_time }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 120px;">
                初始密码
              </div>
            </template>
            <div style="width: 150px">
              {{ activeObj.login_pwd }}
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'StorePage',

  data() {
    return {
      userPrower: '', // 用户权限
      name: '', // 姓名
      company_name: '', // 公司名称
      user_no: '', // 用户编号
      phone: '', // 手机号
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      activeObj: {},
      dialogDetailVisible: false,
      baseurl: '',
    };
  },

  mounted() {
    this.baseurl = this.$baseUrl
    let userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      this.userPrower = userInfo.prower
    } else {
      this.$http({
        method: 'post',
        url: 'user_exit'
      })
      this.$router.push({
        path: '/login'
      })
    }
    this.getData()
  },

  methods: {
    getData() {
      this.loading = true
      this.$http({
        method: 'post',
        url: `/personal/find?page=${this.currentPage}&pageSize=${this.pageSize}`,
        params: {
          user_no: this.user_no,
          name: this.name,
          phone: this.phone
        }
      })
      .then(res => {
        this.loading = false
        if (res.errno == 0) {
          const { data, page, pageSize, count } = res.data
          this.tableData = data
          this.currentPage = page
          this.pageSize = pageSize
          this.total = count
        } else {
          this.$message.error('查询失败')
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('服务端异常，查询失败')
        console.error('查询异常：', err.message);
      })
    },
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      return 'background-color: #F2F2F2;color:#101010;'
    },
    onSearch() {
      this.currentPage = 1
      this.getData()
    },
    toAddStorePage() {
      this.$router.push({
        path: '/addPersonal'
      })
    },
    // 页码改变
    handleCurrentChange(page) {
      this.currentPage = page
      this.getData()
    },
    // 查看名片详情
    showDetail(row) {
      this.activeObj = row
      this.dialogDetailVisible = true
    },
    onUpdateState({ row, $index }) {
      const status = row.status == '1' ? '2' : '1'
      this.$confirm(`确定要${row.status == '1' ? '停用' : '启用'} ${row.name} 的账号吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$http({
          method: 'post',
          url: '/personal/update',
          params: {
            id: row.id,
            status
          }
        })
        .then(res => {
          this.loading = false
          if (res.errno == 0) {
            this.$message.success('操作成功')
            this.getData()
          } else {
            this.$message.error('操作失败')
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('操作异常')
        })
      }).catch(() => {});
    },
    onUpdate(scope) {
      sessionStorage.setItem('updatePersonal', JSON.stringify(scope.row))
      this.$router.push({
        path: '/updatePersonal',
        query: {
          id: scope.row.id
        }
      })
    },
    onDelete(scope) {
      this.$confirm(`确定要删除 ${scope.row.name} 的名片吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            method: 'post',
            url: '/personal/delete',
            params: {
              id: scope.row.id
            }
          })
          .then(res => {
            if (res.errno == 0) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error('服务端异常，网点删除失败')
            }
          })
          .catch(err => {
            this.$message.error('服务端异常，网点删除失败')
          })
        }).catch(() => {});
    },
    // 查看图片弹框关闭
    imageDialogClose() {
      this.activeObj = {}
      this.dialogDetailVisible = false
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: #fff;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 20px 25px;
  overflow-y: scroll;

  .page-top-tool {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }
}

/* 修改滚动条样式 */
.page-container::-webkit-scrollbar {
	width: 4px;
}
.page-container::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.active-detail {
  position: relative;
  .shenpi-resuilt-img {
    position: absolute;
    width: 120px;
    top: -70px;
    right: 0px;
    opacity: 0.6;
  }

  .active-images-layout {
    display: flex;
    flex-wrap: wrap;
    .active-images-item {
      margin: 20px;
      cursor: pointer;
    }
  }
}

.active-detail-dialog {
  height: 480px;
  overflow-y: scroll;
}
.active-detail-dialog-bottom {
  margin-top: 20px;
  text-align: right;
}

/* 修改滚动条样式 */
.active-detail-dialog::-webkit-scrollbar {
	width: 4px;
}
.active-detail-dialog::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.copy-link {
  margin-left: 10px;
  color: #409EFF;
}
.copy-link:hover {
  cursor: pointer;
}
.url-style {
  text-decoration: none;
  color: #409EFF;
}
</style>